import * as React from 'react';

import {useQuery, useMutation} from '@apollo/react-hooks';

import {EmailSequenceProgression} from 'shells/sequence-progression/email-sequence-progression';

import type {
    CancelDripSequenceForEntity as CancelDripSequenceForEntityMutation,
    CancelDripSequenceForEntityVariables as CancelDripSequenceForEntityMutationVariables,
    GetAccountDripSequenceProgressions as GetAccountDripSequenceProgressionsQuery,
    GetAccountDripSequenceProgressionsVariables as GetAccountDripSequenceProgressionsQueryVariables,
} from 'nutshell-graphql-types';

import CANCEL_DRIP_PROGRESSION from '../../../email-marketing/drip-sequences/recipient-modal/graphql/mutations/cancel-drip-sequence-for-entity.graphql';
import {MessageBodyPreviewModal} from '../../../email-marketing/drip-sequences/recipient-modal/message-body-preview-modal';

import GET_ACCOUNT_DRIP_SEQUENCE_PROGRESSIONS from './graphql/queries/get-account-drip-sequence-progressions.graphql';

type Props = {
    accountId: string;
};

export function CompanyDripSequenceProgressionSection(props: Props) {
    const [editionToShow, setEditionToShow] = React.useState<
        | {
              templateId: string;
              entityId: string;
          }
        | null
        | undefined
    >(undefined);

    const [cancelDripProgression] = useMutation<
        CancelDripSequenceForEntityMutation,
        CancelDripSequenceForEntityMutationVariables
    >(CANCEL_DRIP_PROGRESSION);

    const {data, refetch} = useQuery<
        GetAccountDripSequenceProgressionsQuery,
        GetAccountDripSequenceProgressionsQueryVariables
    >(GET_ACCOUNT_DRIP_SEQUENCE_PROGRESSIONS, {
        variables: {accountId: props.accountId},
        notifyOnNetworkStatusChange: true,
    });

    // @ts-expect-error
    const emailSequences = [];
    if (data && data.account && data.account.contacts) {
        data.account.contacts.edges.forEach((contact) =>
            contact.node.dripProgressions.forEach((sequence) => {
                if (sequence.nextEdition && sequence.nextEditionSendTime && sequence.campaign) {
                    emailSequences.push({
                        id: sequence.id,
                        name: sequence.campaign.name,
                        htmlUrlPath: sequence.campaign.htmlUrlPath,
                        length: sequence.campaign.editions.totalCount,
                        totalSent: sequence.numEditionsSent,
                        sendTime: sequence.nextEditionSendTime,
                        nextEdition: sequence.nextEdition
                            ? {
                                  ...sequence.nextEdition,
                                  emailTemplate: sequence.nextEdition.emailTemplate
                                      ? {
                                            id: sequence.nextEdition.emailTemplate.id,
                                        }
                                      : null,
                              }
                            : null,
                        entity: {
                            id: contact.node.id,
                            name: contact.node.name,
                            htmlUrl: contact.node.htmlUrl,
                        },
                        isPaused: Boolean(sequence.campaign.status === 'PAUSED'),
                    });
                }
            })
        );
    }

    return emailSequences.length ? (
        <>
            <div className='mb-16'>
                <EmailSequenceProgression
                    label='Drip sequences'
                    isDripSequence={true}
                    // @ts-expect-error
                    emailSequences={emailSequences}
                    entityType='company'
                    showPreviewModal={(emailTemplateId, entityId) => {
                        setEditionToShow({templateId: emailTemplateId, entityId: entityId});
                    }}
                    onCancelSequenceProgression={(dripProgressionId: string) =>
                        cancelDripProgression({
                            variables: {
                                dripProgressionDeleteInput: {
                                    dripProgressionId,
                                },
                            },
                        }).then(() => refetch())
                    }
                />
            </div>
            {editionToShow ? (
                <MessageBodyPreviewModal
                    onClose={() => {
                        setEditionToShow(undefined);
                    }}
                    emailTemplateId={editionToShow.templateId}
                    entityId={editionToShow.entityId}
                />
            ) : undefined}
        </>
    ) : null;
}
